import { SET_TARGET_USER_ID } from "../../action-types";

export default function userId(state = null, action) {
  if (action.type === SET_TARGET_USER_ID) {
    return action.value;
  }

  return state;
}
